import Image from '@/components/Image'
import RetainQueryLinkDefault from '@/components/RetainQueryLink/RetainQueryLinkDefault'
import { useTonMachines } from '@/contexts/machines'
import { useTonPlans } from '@/contexts/plans'
import { useGetMachinePriceDetails } from '@/hooks/useGetMachinePriceDetails'

export function MachinesColumn({
  onMachineClick
}: {
  onMachineClick?: () => void
}) {
  const { getMachinePriceDetails } = useGetMachinePriceDetails()
  const { plansByType } = useTonPlans()
  const { machinesByCatalog, machinesDetailsByRefID } = useTonMachines()

  const transactionalPlans = plansByType.get('transactional') || []

  const allMachinesByCatalog = transactionalPlans
    .map((transactionalPlan) => {
      if (!!transactionalPlan.catalog) {
        return machinesByCatalog.get(transactionalPlan.catalog)
      }
    })
    .filter((catalog) => !!catalog)

  const allMachinesByCatalogSorted = allMachinesByCatalog.sort((a, b) => {
    const firstValue = Number(a[0].amount)
    const secondValue = Number(b[0].amount)
    return firstValue - secondValue
  })

  // NOTE: This is the cheapest machine by catalog
  const machines = allMachinesByCatalogSorted[0]

  if (!machines) return null

  return (
    <>
      {machines.map((machine) => {
        const machineDetails = machinesDetailsByRefID.get(machine.refID)

        if (!machineDetails) return null

        const machineImages = machineDetails.image
        const machinePopularName = machineDetails.name

        const { installmentValue, installmentParcel } = getMachinePriceDetails({
          id: machine.id,
          refID: machine.refID,
          amount: machine.amount,
          original_price: machine.original_price
        })

        return (
          <RetainQueryLinkDefault
            key={`machine-menu-${machine.refID}`}
            href={machineDetails.linkToProduct}
            prefetch={false}
            id={`btn-maquininha-${machine.refID}`}
            className="flex items-center p-16"
            ctaReference={`Sub menu | Maquininhas | Maquininha ${machinePopularName}`}
            onClick={onMachineClick}
          >
            <Image
              src={`ton-cms/prd/${machineImages.front}.webp`}
              width={40}
              height={60}
              alt={`Maquininha ${machine.name}`}
              className="max-w-full h-auto"
            />
            <div className="ml-12">
              <p className="font-medium">
                {`Maquininha ${machinePopularName}`}
              </p>
              <p className="mt-2 text-display-600 paragraph-14">
                {`À partir de ${installmentParcel}x de R$ ${installmentValue}`}
              </p>
            </div>
          </RetainQueryLinkDefault>
        )
      })}
    </>
  )
}
